import { render, staticRenderFns } from "./ChessPieces.vue?vue&type=template&id=ecd654da&lang=pug"
import script from "./ChessPieces.vue?vue&type=script&lang=js"
export * from "./ChessPieces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports